import { render } from "./pageEdit.vue?vue&type=template&id=0b658174&scoped=true"
import script from "./pageEdit.vue?vue&type=script&lang=js"
export * from "./pageEdit.vue?vue&type=script&lang=js"

import "./pageEdit.vue?vue&type=style&index=0&id=0b658174&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b658174"],['__file',"src/views/exhibitionManage/exHibitionPageConfig/components/pageEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b658174"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b658174', __exports__)) {
    console.log('reload')
    api.reload('0b658174', __exports__)
  }
  
  module.hot.accept("./pageEdit.vue?vue&type=template&id=0b658174&scoped=true", () => {
    console.log('re-render')
    api.rerender('0b658174', render)
  })

}


export default __exports__